import React from "react";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { BasketApp } from "../../apps/checkout/BasketApp";

import styles from "./index.module.scss";

/**
 * The `#basket-app` mount point of the basket document. The basket app lives
 * in the document's React tree (mounted client-side by BasketApp; the
 * dependency tree is not SSR-safe). The #basket-app id is retained for the
 * 60-minute redirect timer in apps/checkout/index.tsx.
 */
export const BasketPageBody = (): React.JSX.Element => {
    const basketAppRef = React.useRef<HTMLDivElement>(null);
    // SiteHeader's promo bar (`.search-nav__promo`) isn't in this subtree --
    // it's chrome rendered by PageSkeleton -- so its presence has to be
    // detected via the document rather than props. When present it needs
    // extra clearance above the basket app.
    React.useEffect(() => {
        const document = getDocument();
        if (!document?.querySelector(".search-nav__promo")) {
            return;
        }
        if (basketAppRef.current) {
            basketAppRef.current.style.marginTop = "27px";
        }
    }, []);
    return (
        <div
            id="basket-app"
            className={styles.basketContainer}
            ref={basketAppRef}
        >
            <BasketApp />
        </div>
    );
};
